import { FC, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { decodeToken } from "react-jwt";

interface AuthGuardProps {
  Component: FC<any>;
  [key: string]: any;
}
 
const AuthGuard: FC<AuthGuardProps> = ({ Component, ...rest }) => {
  const [allowed, setAllowed] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("accessToken") as string;
    if (token) {
      const currentTime = Date.now().valueOf() / 1000;
      const decodedToken = decodeToken(token) as any;
      if (decodedToken && decodedToken.exp < currentTime) {
        setAllowed(1);
      } else {
        setAllowed(2);
      }
    } else {
      setAllowed(1);
    }
  }, []);

  return (
    <>
      {allowed === 2 && <Component {...rest}/>}
      {allowed === 1 && <Navigate to="/" replace={true} />}
    </>
  );
};
 
export default AuthGuard;